import { ContractClient } from "@lib/ShiOneClient";
import { useQuery } from "@tanstack/react-query";
import { useApi } from "../../../utils";
import type { Contract } from "shared-ui/src/features/projects-feature/canonical";
import { mapToContract } from "../toCanonical";

const useGetContractById = (id: number) => {
  const isValidContractId = Number.isInteger(id) && id > 0;
  const api = useApi(ContractClient);

  const getContractById = async (): Promise<Contract | null> => {
    const response = await api.getContract(id);
    return mapToContract(response);
  };

  return useQuery<Contract | null, Error>({
    queryKey: [`contract-detail-${id}`],
    queryFn: getContractById,
    enabled: isValidContractId,
  });
};

export default useGetContractById;
